var map = {
	"./im-audio-message/im-audio-message.vue": "0009",
	"./im-chat/im-chat.vue": "8148",
	"./im-custom-case/im-custom-case.vue": "a07d",
	"./im-custom-inspect/im-custom-inspect.vue": "b6a6",
	"./im-custom-invite-referral/im-custom-invite-referral.vue": "7404",
	"./im-custom-invite/im-custom-invite.vue": "2947",
	"./im-custom-message/im-custom-message.vue": "65e1",
	"./im-custom-prescription/im-custom-prescription.vue": "eb9b",
	"./im-custom-prescription/kc-my-show.vue": "f40c",
	"./im-custom-register/im-custom-register.vue": "0b89",
	"./im-custom-surgery/im-custom-surgery.vue": "dc2c",
	"./im-custom-text/im-custom-text.vue": "a0c9",
	"./im-file-message/im-file-message.vue": "f4fe",
	"./im-image-message/im-image-message.vue": "65cc",
	"./im-image-text-message/im-image-text-message.vue": "1e38",
	"./im-invite-message/im-invite-message.vue": "9ffe",
	"./im-list-message/im-list-message.vue": "12a6",
	"./im-message/im-message.vue": "d982",
	"./im-quick-reply/im-quick-reply.vue": "cf75",
	"./im-quick-reply/quick-reply-list.vue": "ebfc",
	"./im-revoke/im-revoke.vue": "63b2",
	"./im-static-list-message/im-static-list-message.vue": "82ba",
	"./im-system/im-system.vue": "3307",
	"./im-text-message/im-text-message.vue": "a738",
	"./im-textarea/chatFuncBtns.vue": "83b5",
	"./im-textarea/im-textarea.vue": "0e1f",
	"./im-video-file-message/im-video-file-message.vue": "0c15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3065";